import type { AgentPageSeo, FAQItem } from "../agent-seo";

export const faqs: FAQItem[] = [
  {
    question: "What is the Inbox Apply Agent?",
    answer:
      "Inbox Apply sends your application straight to the people who hire. After you apply, it finds the recruiter or hiring manager for the role and sends them a short, personal message with your strongest result.",
  },
  {
    question: "How does it find the right person?",
    answer:
      "For each job it looks for the recruiter or hiring manager at that company who hires for the team, and shows you who it found before anything is sent.",
  },
  {
    question: "What does the message say?",
    answer:
      "It names the role you applied for, gives one result from your resume that matches the job and makes a small, clear ask. LinkedIn notes stay under the 300-character limit.",
  },
  {
    question: "Can I review messages before they go out?",
    answer:
      "Yes. You can read and edit any message, and every message waits in your outreach queue until it is sent.",
  },
  {
    question: "Why are messages sent through the day?",
    answer:
      "Messages are spaced out instead of sent all at once, which keeps your outreach looking personal and protects your LinkedIn account.",
  },
  {
    question: "Can it email the hiring manager too?",
    answer:
      "Yes. Where a verified work email is available, Inbox Apply can send an email with your tailored resume attached and show you when it is opened.",
  },
  {
    question: "Does it work with Live Apply and Auto Apply?",
    answer:
      "Yes. Turn on recruiter messaging for selected jobs and each application is paired with a message to the hiring team.",
  },
];

export const seo: AgentPageSeo = {
  slug: "inbox-apply",
  name: "Inbox Apply Agent",
  title: "Inbox Apply Agent: Message the Recruiter Every Time | MindMyJob",
  description:
    "Apply and reach the hiring team in one step. Inbox Apply finds the recruiter for each job, sends a personal note with your best result and tracks every reply.",
  keywords: [
    "message recruiter after applying",
    "linkedin message to recruiter",
    "email hiring manager",
    "recruiter outreach automation",
    "linkedin connection note job",
    "find recruiter for job",
    "job application follow up",
    "direct application to hiring manager",
    "get noticed by recruiters",
    "ai recruiter outreach",
  ],
  ogImage: "/assets/images/ai-agents/inbox-apply/hero-recruiter.png",
  ogImageAlt:
    "MindMyJob Inbox Apply Agent finding the recruiter for a job after applying",
  featureList: [
    "Recruiter and hiring manager finder",
    "Personal notes under 300 characters",
    "Paired with every application",
    "Outreach queue with paced sending",
    "Hiring manager email with tailored resume",
    "Sent, accepted, opened and replied tracking",
  ],
  faqs,
};
